// extracted by mini-css-extract-plugin
export var alt = "ReservationCard-module--alt--a3d3f";
export var container = "ReservationCard-module--container--89746";
export var desktopOnly = "ReservationCard-module--desktopOnly--18b98";
export var folioRequest = "ReservationCard-module--folioRequest--4496b";
export var freeStay = "ReservationCard-module--freeStay--af395";
export var hotelName = "ReservationCard-module--hotelName--b4e9e";
export var main = "ReservationCard-module--main--88e35";
export var mobileOnly = "ReservationCard-module--mobileOnly--47d61";
export var textLeft = "ReservationCard-module--textLeft--72e67";
export var visuallyHidden = "ReservationCard-module--visuallyHidden--0d311";